function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.364 18.364v2.727a.91.91 0 01-.91.909H6.546a.91.91 0 01-.909-.91v-2.726h-.909A2.727 2.727 0 012 15.636v-4.545a2.727 2.727 0 012.727-2.727h.91V2.909A.91.91 0 016.544 2h10.91a.91.91 0 01.909.91v5.454h.909A2.727 2.727 0 0122 11.09v4.545a2.727 2.727 0 01-2.727 2.728h-.91zm0-1.819h.909a.91.91 0 00.909-.909v-4.545a.91.91 0 00-.91-.91H4.728a.91.91 0 00-.909.91v4.545c0 .502.407.91.91.91h.908v-2.728a.91.91 0 01.91-.909h10.909a.91.91 0 01.909.91v2.726zM7.454 8.364h9.091V3.818h-9.09v4.546zm0 11.818h9.091v-5.455h-9.09v5.455z"
});

var SvgPrinter = function SvgPrinter(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/printer.14201aad.svg";
export { SvgPrinter as ReactComponent };